import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinnerSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M20.9992 12H22.9992C22.9992 5.92487 18.0744 1 11.9992 1C5.9241 1 0.999237 5.92487 0.999237 12H2.99924C2.99924 7.02944 7.02867 3 11.9992 3C16.9698 3 20.9992 7.02944 20.9992 12Z" })]
});
const ForwardRef = forwardRef(SvgSpinnerSmall);
export { ForwardRef as ReactComponent };
